import { useEffect, useState } from "react";
import { Check, Copy } from "lucide-react";
import styles from "./CopyButton.module.css";

export default function CopyButton({ value, label = "Copy" }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timeout = setTimeout(() => setCopied(false), 1500);
    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      // Clipboard can be blocked (e.g. insecure origin); fail quietly
    }
  };

  const Icon = copied ? Check : Copy;

  return (
    <button type="button" className={styles.button} onClick={handleCopy} aria-label={copied ? "Copied" : label}>
      <Icon size={16} strokeWidth={1.75} aria-hidden="true" />
    </button>
  );
}
